import React from "react";
import { useLocation } from "react-router-dom";
import ContentGuard from "../components/ContentGuard";

/**
 * Placeholder page generator
 * Automatically shows Coming Soon based on route
 */
const PlaceholderPage = () => {
  const location = useLocation();

  // Extract readable name from path
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const moduleName = pathSegments
    .map((segment) =>
      segment
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    )
    .join(" > ");

  return (
    <ContentGuard
      hasContent={false}
      fallbackMessage={`The ${moduleName} module is coming soon!`}
    >
      <div />
    </ContentGuard>
  );
};

export default PlaceholderPage;
